import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from '../../Asset/image/tamara_logo.png';
import './SideBar.css';
import Dropdown from 'react-bootstrap/Dropdown';
import SubscriptionModal from '../../CommonComponents/SubscriptionModal';
import ProfileSettingsModal from '../../CommonComponents/ProfileSettingsModal';
import CustomImage from "../../CommonComponents/CustomImage";
import Setting from '../../Asset/image/settings.png';
import Guest from '../../Asset/image/blank_profile.png';
import { signUpType } from '../../data/constants';
import Subscription from '../../Asset/image/subscription.png';
import ProfileImg from '../../Asset/image/placeholder.png';
import { useAuth } from "../../Context/AuthProvider";
import Loader from "../../CommonComponents/Loader";
import LogoutModal from "../../CommonComponents/LogoutModal";

const ProfileDropdown = ({ show, setShow, onDeleteAccount, profileShow, setProfileShow, handleProfileShow, handleDeleteAccount, handleLogoutShow, logoutShow, deleteAccount, setDeleteAccount, setLogoutShow, userImage }) => {
    const { logout, setUser, user } = useAuth()

    const renderLoader = () => {
        return (
            <Loader
                visible={false}
                emptyTextKey={'EmptyHistory'}
                style={{ top: 0, position: "relative", color: "white", fontWeight: 25 }} />
        )
    }

    return (
        <>
            <div style={{
                display: "flex",
                justifyContent: 'end',
                alignItems: "center"
            }} className='py-3'>
                {/* <CustomImage style={{
                width: 'auto',
                height: '25px',
                marginLeft: 10
              }} src={Subscription} onClick={handleShow} /> */}
                <div className='position-relative'>
                    <CustomImage style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: "15px",
                        marginLeft: 35
                    }} src={userImage ? userImage : Guest} />
                    <Dropdown>
                        <Dropdown.Toggle id="dropdown-basic" variant="success" style={{
                            width: '20px',
                            height: '20px',
                            // marginLeft: 15,
                            backgroundColor: "white",
                            borderRadius: "80px",
                            position: 'absolute',
                            bottom: 0,
                            right: 0, padding: "0px"
                        }}><img src={Setting} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <div className="d-flex justify-content-space-between profile_box">
                                <div>
                                    {userImage ?
                                        <CustomImage style={{
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: "15px",
                                            zIndex: 10,
                                        }} src={userImage} /> :
                                        <CustomImage style={{
                                            width: "auto",
                                            height: '50px',
                                            borderRadius: "10px",
                                            zIndex: 10,
                                        }} src={Guest} />
                                    }
                                </div>
                                <div >
                                    <p className="text-label" style={{ overflowWrap: "break-word", inlineSize: "190px" }} >{user?.name?.length > 10 ? user?.name?.slice(0, 10) + '...' : user?.name}</p>
                                    <p className="white-text-label" style={{ overflowWrap: "break-word", inlineSize: "110px" }} >{user?.email?.slice(0, 14) + '...'}</p>
                                </div>
                            </div>
                            {user?.signuptype === signUpType?.guest ?
                                <>
                                    <Dropdown.Item href="#/action-1" onClick={() => { logout() }}>Log In</Dropdown.Item>
                                </>
                                :
                                <>
                                    <Dropdown.Item href="#/action-1" onClick={handleProfileShow}>Profile Settings</Dropdown.Item>
                                    <Dropdown.Item href="#/action-2" onClick={handleDeleteAccount}>Delete Account</Dropdown.Item>
                                    <Dropdown.Item href="#/action-3" onClick={handleLogoutShow}>Logout</Dropdown.Item>
                                </>}
                        </Dropdown.Menu>
                    </Dropdown>

                </div>
            </div>
            <SubscriptionModal show={show} setShow={setShow} />
            <LogoutModal show={logoutShow} setShow={setLogoutShow} title="Logout" data="logout" onYesClick={() => logout()} />
            <LogoutModal show={deleteAccount} setShow={setDeleteAccount} title="Delete" data="delete this account" onYesClick={onDeleteAccount} />
            {profileShow && <ProfileSettingsModal show={profileShow} setShow={setProfileShow} />}
        </>
    );
}

export default ProfileDropdown;